<template>
  <div id="DisposalInvoiceReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Disposal Invoice Listing</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'disposalInvoiceListing'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'disposalInvoiceListing'" :position="'top'">
                </custom-pagination>

                <vue-good-table
                        mode="remote"
                        ref="disposallInvoiceReportTable"
                        title="Disposal Invoice Listing"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-select-all="onSelectAll"
                        @on-selected-rows-change="selectionChanged"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                        :select-options="{
                            enabled: false,
                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                            selectionInfoClass: 'custom-class',
                            selectionText: 'rows selected',
                            clearSelectionText: 'clear',
                        }"
                        :search-options="{
                        enabled: false,
                        }"

                        >
                    </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "DisposalInvoiceReport",
   metaInfo() {
            return {title: "Disposal Invoice Listing | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    permissions:[],
    rows: [],
    action: '',
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px'
      },
      {
        label: "Disposal Date",
        field: "disposal_dt",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false
      },
      {
          label: 'Disposal Type',
          field: 'disposal_type',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
      {
          label: 'Sales Person',
          field: 'sales_person',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
          sortable:true,
      },
      {
          label: 'Customer Number',
          field: 'customer',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Customer  Name',
          field: 'customer_name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Invoice Number',
          field: 'inv_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
        label: "Date Created",
        field: "created_at",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
      {
          label: 'Disposal Invoice Amount',
          field: 'inv_amt',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Disposal Proceed',
          field: 'disposal_proceed',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
          sortable:true,
      },
      {
          label: 'Original Cost',
          field: 'original_cost',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Accumulated Depreciation',
          field: 'acc_depreciation',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:true,
          width:'90px',
      },
      {
          label: 'Cost Of Sale',
          field: 'sold_price',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false
      },
      {
          label: 'Gain / (Loss)',
          field: 'gain_loss',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
      {
          label: 'Misc Charge Amount',
          field: 'misc_amount',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
      {
          label: 'Serial Number',
          field: 'vin_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Gross Weight',
          field: 'gross_weight',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Customer Address Line 1',
          field: 'customer_addr',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Customer Address Line 2',
          field: 'customer_addr_2',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Customer Address Line 3',
          field: 'customer_addr_3',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
      {
          label: 'Customer City',
          field: 'city',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Customer Postal Zip Code',
          field: 'postal_code',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Province State Code',
          field: 'state_code',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          sortable:false,
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'disposal_invoice') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
   mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.disposallInvoiceReportTable.unselectAllInternal();
    },
    exportReports: function() {
        var self = this;
        this.action = "export";
        this.loadList();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['disposallInvoiceReportTable'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['disposallInvoiceReportTable'].selectedRows[i].inv_no)
      }

      $.ajax({
        url: process.env.ROOT_API + "/disposal-invoice-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              self.loadList();

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
        }
      });


    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/DisposalInvoiceReport.vue